import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './style.css';

class CityButton extends Component {
    render() {
        const { data, isActive, link } = this.props;
        const activeClassname = isActive ? 'active' : '';

        return (
            <Link to={link} className={`city-button ${activeClassname}`}>
                {data.title}
            </Link>
        );
    }
}

export default CityButton;



// WEBPACK FOOTER //
// ./src/components/CityButton/index.js